import React from "react";
import MyProfileRightBtnChange from "components/myprofile/features/btn.change";
import SingleInfo from "components/myprofile/features/single.info";

export default function MyProfileRightContentInfoView({
  boxName,
  data,
  handleEvents,
}) {
  return (
    <div
      className={boxName + " row"}
      style={{
        width: "98%",
        margin: "0 auto",
        marginTop: "25px",
        paddingLeft: "20px",
        paddingRight: "20px",
      }}
    >
      <h3>Your profile</h3>
      <div
        className="col s6"
        style={{ paddingLeft: "5px", paddingRight: "5px" }}
      >
        <div className="row">
          <SingleInfo title="Work E-Mail" name="email" value={data?.email} />
          <SingleInfo title="Position" name="position" value={data?.position} />
          <SingleInfo
            title="Department"
            name="department"
            value={data?.dept_names ? data.dept_names.join(", ") : "-"}
          />
        </div>
        <div className="row">
          <SingleInfo
            title="E-leave Approver"
            name="eleave_approver"
            value={data?.eleave_approver_name}
          />
          <SingleInfo
            title="E-leave Co Approver"
            name="eleave_co_approver"
            value={data?.eleave_co_approver_name}
          />
          <SingleInfo
            title="KPI supervisor"
            name="kpi_approver"
            value={
              data?.kpi_approver_name === ""
                ? data?.eleave_approver_name
                : data?.kpi_approver_name
            }
          />
          <SingleInfo
            title="KPI Co-supervisor"
            name="kpi_co_approver"
            value={data?.kpi_co_approver_name}
          />
        </div>
        <div className="row">
          <SingleInfo
            title="Title/Salutation"
            name="title"
            value={data?.title}
          />
          <SingleInfo title="First name" name="fname" value={data?.fname} />
          <SingleInfo title="Last name" name="lname" value={data?.lname} />
          <SingleInfo
            title="Local name"
            name="contact_fullname_local_language"
            value={data?.contact_fullname_local_language}
          />
          <SingleInfo title="Nickname" name="nickname" value={data?.nickname} />
          <SingleInfo title="Gender" name="gender" value={data?.gender} />
          <SingleInfo
            title="Nationality"
            name="nationality"
            value={data?.nationality}
          />
          <SingleInfo
            title="Birthday"
            name="birthday"
            value={
              data?.birthday ? new Date(data.birthday).toDateString() : "-"
            }
          />
          <SingleInfo
            title="Native Language"
            name="native_language"
            value={data?.native_language}
          />
          <SingleInfo
            title="Marital Status"
            name="marital_status"
            value={data?.marital_status}
          />
        </div>
      </div>
      <div
        className="col s6"
        style={{ paddingLeft: "5px", paddingRight: "5px" }}
      >
        <div className="row">
          <SingleInfo
            title="Personal E-mail"
            name="contact_email"
            value={data?.contact_email}
          />
          <SingleInfo
            title="Home Phone"
            name="contact_home_phone"
            value={data?.contact_home_phone}
          />
          <SingleInfo
            title="Mobile Phone"
            name="contact_mobile"
            value={data?.contact_mobile}
          />
          <SingleInfo
            title="Address 1"
            name="contact_address"
            value={data?.contact_address}
          />
          <SingleInfo
            title="Address 2"
            name="contact_street"
            value={data?.contact_street}
          />
          <SingleInfo
            title="City"
            name="contact_city"
            value={data?.contact_city}
          />
          <SingleInfo
            title="State/Province"
            name="contact_state"
            value={data?.contact_state}
          />
          <SingleInfo
            title="Country"
            name="contact_country"
            value={data?.contact_country}
          />
          <SingleInfo
            title="Zip Code"
            name="contact_zipcode"
            value={data?.contact_zipcode}
          />
          <SingleInfo
            title="Emergency Contact Name"
            name="contact_emergency_contact_name"
            value={data?.contact_emergency_contact_name}
          />
          <SingleInfo
            title="Emergency Contact Number"
            name="contact_emergency_contact_number"
            value={data?.contact_emergency_contact_number}
          />
        </div>
      </div>
      <div className="col s12" style={{ padding: "0px 12px" }}>
        <MyProfileRightBtnChange
          data={data}
          handleEvents={handleEvents.OnEdit}
        />
      </div>
    </div>
  );
}
